import CheckoutForm from "components/CheckoutForm"
import VueComponent from "../vue_component"

export default VueComponent(CheckoutForm)
